import { useEffect } from "react";
import Hero from "@/components/home/Hero";
import ShopByCategory from "@/components/home/ShopByCategory";
import FeaturedProducts from "@/components/home/FeaturedProducts";
import Collections from "@/components/home/Collections";
import TrustBadges from "@/components/home/TrustBadges";
import CustomerReviews from "@/components/home/CustomerReviews";
import Newsletter from "@/components/home/Newsletter";

export default function HomePage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
    // Mark that we're on home page - this will clear filters when navigating to products
    try {
      sessionStorage.setItem("aarsa_previous_route", "/");
    } catch (error) {
      // Ignore storage errors
    }
  }, []);

  return (
    <div className="min-h-screen">
      <main>
        <Hero />
        <ShopByCategory />
        <FeaturedProducts />
        <Collections />
        <TrustBadges />
        <CustomerReviews />
        <Newsletter />
      </main>
    </div>
  );
}
